/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Edit_First_OrderInputs */

const en_orders_edit_first_order = /** @type {(inputs: Orders_Edit_First_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit First Order`)
};

const es_orders_edit_first_order = /** @type {(inputs: Orders_Edit_First_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar primer pedido`)
};

/**
* | output |
* | --- |
* | "Edit First Order" |
*
* @param {Orders_Edit_First_OrderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_edit_first_order = /** @type {((inputs?: Orders_Edit_First_OrderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Edit_First_OrderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_edit_first_order(inputs)
	return es_orders_edit_first_order(inputs)
});